export default "__VITE_ASSET__xJAQgdiA__"